import { format, isValid, parseISO } from 'date-fns';

export const parseFlightDateTime = (value) => {
  if (!value || value === 'TBD') {
    return null;
  }

  const date = typeof value === 'string' && value.includes('T') && !value.endsWith('Z')
    ? parseISO(value)
    : new Date(value);

  if (!isValid(date) || date.getFullYear() < 1971) {
    return null;
  }

  return date;
};

export const normalizeDateTimeLocal = (value, fallbackValue = null) => {
  const source = value || fallbackValue;
  if (!source) {
    return '';
  }

  const str = String(source).trim();
  if (!str || str === 'TBD') {
    return fallbackValue && fallbackValue !== value
      ? normalizeDateTimeLocal(fallbackValue)
      : '';
  }

  const dateTimeMatch = str.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/);
  if (dateTimeMatch) {
    return `${dateTimeMatch[1]}T${dateTimeMatch[2]}`;
  }

  // MySQL / API datetimes often use a space instead of T.
  const spaceDateTimeMatch = str.match(/^(\d{4}-\d{2}-\d{2})[ ]+(\d{2}:\d{2})/);
  if (spaceDateTimeMatch) {
    return `${spaceDateTimeMatch[1]}T${spaceDateTimeMatch[2]}`;
  }

  const dateOnlyMatch = str.match(/^(\d{4}-\d{2}-\d{2})$/);
  if (dateOnlyMatch) {
    const fallbackTime = fallbackValue
      ? String(fallbackValue).match(/(?:T|[ ])(\d{2}:\d{2})/)?.[1]
      : null;
    return `${dateOnlyMatch[1]}T${fallbackTime || '09:00'}`;
  }

  const parsed = parseFlightDateTime(str);
  if (!parsed) {
    return '';
  }

  const pad = (part) => String(part).padStart(2, '0');
  return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}T${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
};

export const formatFlightSchedule = (value, locale) => {
  const date = parseFlightDateTime(value);
  if (!date) {
    return null;
  }

  return {
    time: format(date, 'h:mm a', locale ? { locale } : undefined),
    date: format(date, 'EEE, MMM d, yyyy', locale ? { locale } : undefined),
    shortDate: format(date, 'MMM d, yyyy', locale ? { locale } : undefined),
    full: format(date, 'EEE, MMM d · h:mm a', locale ? { locale } : undefined),
  };
};

export const parseRouteAirportCodes = (routeLabel) => {
  if (!routeLabel || typeof routeLabel !== 'string') {
    return { origin: null, destination: null };
  }

  const match = routeLabel.match(/^([A-Z0-9]{3})\s*→\s*([A-Z0-9]{3})$/);
  if (!match) {
    return { origin: null, destination: null };
  }

  return { origin: match[1], destination: match[2] };
};

export const formatFlightLegScheduleLine = (leg, locale) => {
  const departure = formatFlightSchedule(leg?.departure_time, locale);
  const arrival = formatFlightSchedule(leg?.arrival_time, locale);

  if (departure && arrival) {
    return `${departure.full} → ${arrival.full}`;
  }
  if (departure) {
    return departure.full;
  }
  if (arrival) {
    return arrival.full;
  }

  return null;
};
